import React from 'react';
import { Container } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import { Layout } from 'features/common/components/Layout';
import { HotelSearchCard as Component } from 'features/hotels/components/HotelSearchCard';

const useStyles = makeStyles((theme) => ({
	paper: {
		marginTop: theme.spacing(8),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'left',
	},
}));

function HotelSearch(): JSX.Element {
	const classes = useStyles();

	return (
		<Layout>
			<Container component="main" maxWidth="xl">
				<div className={classes.paper}>
					<Component />
				</div>
			</Container>
		</Layout>
	);
}

export default HotelSearch;
